import React, { useState } from 'react';
import { supabase } from './supabase';

function Auth({ onLogin }) {
  const [tab, setTab] = useState('giris');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const kayitOl = async () => {
    if (!name || !email || !password) { setError('Tüm alanları doldurun'); return; }
    if (password.length < 6) { setError('Şifre en az 6 karakter olmalı'); return; }
    setLoading(true); setError('');
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { full_name: name } }
    });
    if (error) { setError(error.message); }
    else { setSuccess('Hesabın oluşturuldu! Giriş yapabilirsin.'); setTab('giris'); }
    setLoading(false);
  };

  const girisYap = async () => {
    if (!email || !password) { setError('Email ve şifre girin'); return; }
    setLoading(true); setError('');
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) { setError('Email veya şifre hatalı'); }
    else { onLogin(data.user); }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: 'sans-serif' }}>
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #eee', padding: 28, width: '100%', maxWidth: 400 }}>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 18, fontWeight: 500, marginBottom: 24 }}>
          <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#1D9E75' }}></div>
          OddsGuru
        </div>

        <div style={{ display: 'flex', border: '1px solid #eee', borderRadius: 8, overflow: 'hidden', marginBottom: 20 }}>
          <button onClick={() => { setTab('giris'); setError(''); }} style={{ flex: 1, padding: 9, background: tab === 'giris' ? '#fff' : '#f5f5f5', border: 'none', fontWeight: tab === 'giris' ? 500 : 400, cursor: 'pointer', fontSize: 13 }}>Giriş yap</button>
          <button onClick={() => { setTab('kayit'); setError(''); }} style={{ flex: 1, padding: 9, background: tab === 'kayit' ? '#fff' : '#f5f5f5', border: 'none', fontWeight: tab === 'kayit' ? 500 : 400, cursor: 'pointer', fontSize: 13 }}>Üye ol</button>
        </div>

        {error && <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginBottom: 14 }}>{error}</div>}
        {success && <div style={{ background: '#E1F5EE', color: '#085041', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginBottom: 14 }}>{success}</div>}

        {tab === 'kayit' && (
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Ad Soyad</label>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="Adınızı girin" style={{ width: '100%', padding: '9px 12px', border: '1px solid #eee', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
          </div>
        )}

        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>E-posta</label>
          <input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="ornek@email.com" style={{ width: '100%', padding: '9px 12px', border: '1px solid #eee', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>Şifre</label>
          <input value={password} onChange={e => setPassword(e.target.value)} type="password" placeholder="••••••••" style={{ width: '100%', padding: '9px 12px', border: '1px solid #eee', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
        </div>

        <button onClick={tab === 'giris' ? girisYap : kayitOl} disabled={loading}
          style={{ width: '100%', padding: 10, background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
          {loading ? 'Yükleniyor...' : tab === 'giris' ? 'Giriş yap' : 'Üye ol — ücretsiz'}
        </button>

        <p style={{ textAlign: 'center', fontSize: 12, color: '#888', marginTop: 16 }}>
          {tab === 'giris' ? 'Hesabın yok mu?' : 'Zaten üye misin?'}
          <span onClick={() => { setTab(tab === 'giris' ? 'kayit' : 'giris'); setError(''); }} style={{ color: '#1D9E75', cursor: 'pointer', marginLeft: 4 }}>
            {tab === 'giris' ? 'Üye ol' : 'Giriş yap'}
          </span>
        </p>
      </div>
    </div>
  );
}

export default Auth;